import { AppStateService } from "@app/shared/services/app-state.service";
import { Component, OnInit } from "@angular/core";
import { Router, RouterStateSnapshot, ActivatedRoute } from "@angular/router";
import swal from "sweetalert2";

@Component({
  selector: "app-roles-nav-top-bar",
  templateUrl: "./roles-nav-top-bar.component.html",
  styleUrls: ["./roles-nav-top-bar.component.css"]
})
export class RolesNavTopBarComponent implements OnInit {
  loggedIn = false;
  accessToken: string;
  userRole;
  userDetailsObject;
  constructor(
    public router: Router,
    private appState: AppStateService,
    private routerSnapShot: ActivatedRoute
  ) {
    const snapshot = routerSnapShot.snapshot;

    this.userRole = snapshot.parent.routeConfig.path;
  }

  ngOnInit() {
    this.appState.loggedIn.subscribe(
      (response: boolean) => {
        this.loggedIn = response;
      },
      error => {}
    );
    this.userDetails();
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
    }
  }

  techBuyerNavtoAnalystList() {
    this.router.navigate(["tech-buyer/analyst-list"]);
  }
  techVendorNavtoAnalystList() {
    this.router.navigate(["tech-vendor/analyst-list"]);
  }

  techBuyerNavtoTechDomains() {
    this.router.navigate(["tech-buyer/tech-domain-list"]);
  }
  techVendorNavtoTechDomains() {
    this.router.navigate(["tech-vendor/tech-domain-list"]);
  }

  techBuyerNavtoSupport() {
    this.router.navigate(["tech-buyer/support"]);
  }

  techVendorNavtoSupport() {
    this.router.navigate(["tech-vendor/support"]);
  }

  techBuyerNavtoProfile() {
    this.router.navigate(["tech-buyer/my-profile"]);
  }

  techVendorNavtoProfile() {
    this.router.navigate(["tech-vendor/my-profile"]);
  }

  techBuyerNavtoChangePassword() {
    this.router.navigate(["tech-buyer/change-password"]);
  }

  techVendorNavtoChangePassword() {
    this.router.navigate(["tech-vendor/change-password"]);
  }

  logout() {
    this.accessToken = JSON.parse(
      window.sessionStorage.getItem("userDetails")
    ).accessToken;

    this.appState.logout(this.accessToken);

    this.router.navigate(["/signin"]);
    window.sessionStorage.clear();
    window.localStorage.setItem("logoutStatus", "true");
    this.appState.setState(false);
    this.loggedIn = false;
    swal({
      position: "center",
      type: "success",
      title: "Bye",
      showConfirmButton: false,
      timer: 3000,
      text: "See you back soon"
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/core/roles-nav-top-bar/roles-nav-top-bar.component.ts